import { auth, db } from './firebase';
import { doc, getDoc } from 'firebase/firestore';

// Mapping of price IDs to plan levels (Standard or Pro)
const planMapping = {
  'price_1RatOcRvHo620RneKGNASUqx': { name: 'Standard, $49/month', level: 'Standard' },
  'price_1RatOWRvHo620RneHGh5k1gz': { name: 'Pro, $89/month', level: 'Pro' },
  'price_1RatOWRvHo620RneHwIhiuL0': { name: 'Pro, $960/year', level: 'Pro' },
  // Backend / Stripe canonical id (capital W)
  'price_1RatOcRvHo620RneWbkgX4jz': { name: 'Standard, $528/year', level: 'Standard' },
  // Legacy typo stored in some Firestore docs
  'price_1RatOcRvHo620RnewbkgX4jz': { name: 'Standard, $528/year', level: 'Standard' },
};

// Check subscription status and plan level
const checkSubscription = async () => {
  const user = auth.currentUser;
  if (!user) {
    return {
      isAuthenticated: false,
      hasActiveSubscription: false,
      hasSubscription: false,
      subscriptionStatus: null,
      planLevel: null,
      hasUsedTrial: false,
    };
  }

  try {
    const userDocRef = doc(db, 'users', user.uid);
    const userDoc = await getDoc(userDocRef);
    if (!userDoc.exists()) {
      return {
        isAuthenticated: true,
        hasActiveSubscription: false,
        hasSubscription: false,
        subscriptionStatus: null,
        planLevel: null,
        hasUsedTrial: false,
      };
    }

    const data = userDoc.data();
    const subscription = data.subscription || {};
    // Registration seeds subscription.status === 'pending' with no Stripe ids — that is not
    // "has a subscription to manage"; only post-checkout / webhook state counts.
    const isPreCheckoutPlaceholder =
      subscription.status === 'pending' &&
      !subscription.customerId &&
      !subscription.subscriptionId;
    const hasSubscription =
      !!subscription &&
      Object.keys(subscription).length > 0 &&
      !isPreCheckoutPlaceholder;
    const hasActiveSubscription = subscription.status === 'active' || subscription.status === 'trialing';
    const plan = subscription.plan || null;
    const planDetails = plan ? planMapping[plan] : null;
    const planLevel = hasActiveSubscription ? planDetails?.level : null;
    const hasUsedTrial =
      data.subscription?.hasUsedTrial === true || data.hasUsedTrial === true;

    return {
      isAuthenticated: true,
      hasActiveSubscription,
      hasSubscription,
      subscriptionStatus: subscription.status || null,
      planLevel,
      hasUsedTrial,
    };
  } catch (error) {
    console.error('Error checking subscription:', error);
    return {
      isAuthenticated: true,
      hasActiveSubscription: false,
      hasSubscription: false,
      subscriptionStatus: null,
      planLevel: null,
      hasUsedTrial: false,
    };
  }
};

export { checkSubscription };